export default function getVocabolario(nome){
    try{
        // Recupera la stringa JSON dalla sessionStorage
        const arrayJSONRecuperato = sessionStorage.getItem('vocabolario');
        // Converti la stringa JSON in un array di oggetti
        const arrayOggettiRecuperato = JSON.parse(arrayJSONRecuperato);
        // Cerca la variabile "nome" all'interno dell'array di oggetti
        var oggettoTrovato = arrayOggettiRecuperato.find(function(oggetto) {
            return oggetto.nome === nome;
        });
        if(oggettoTrovato !== null && oggettoTrovato.messaggio !== undefined){
            return oggettoTrovato.messaggio
        }
        return null
    }catch (error){
        return null
    }

}
